import { Platform, StyleSheet } from "react-native";
import GlobalStyles from "../../../globalStyles/globalStyles";
import dimensions from "../../../globalStyles/dimensions";

export default StyleSheet.create({
  backBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    // width: "42%",
  },
  backBoxMain: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "95%",
  },
  stickTopBar: {
    width: "100%",
    height: 70,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.5)",
  },
  percentageText: [
    GlobalStyles.bodyText,
    {
      color: "red",
    },
  ],
  previewBox: {
    // width: "22%",
    gap: 6,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  uploadBox: {
    marginTop: 20,
  },
  uploadBoxText: {
    fontSize: 17,
    fontWeight: "400",
    fontFamily: "InterSemiBold",
    opacity: 0.5,
    letterSpacing: -0.3,
  },
  holdAndDrag: {
    fontSize: 15,
    fontWeight: "400",
    fontFamily: "InterRegular",
    opacity: 0.5,
    letterSpacing: -0.3,
  },
  verifyBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 20,
    borderTopWidth: 0.3,
    borderTopColor: "rgba(0, 0, 0, 0.3)",
    borderBottomColor: "rgba(0, 0, 0, 0.3)",
    borderBottomWidth: 0.3,
    height: 60,
  },
  verifyBoxInner: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    // width: "40%",
    justifyContent: "space-between",
  },
  textArea: {
    height: 170,
    fontSize: 14,
    color: "#333",
    backgroundColor: "#F3F1EF",
    borderRadius: 9,
    marginTop: 5,
  },
  exprienceBox: {
    width: Platform.OS === "web" ? '48%' : dimensions.marginHorizontal * 8.5,
    height: 200,
    alignItems: 'center',
  },
  exprienceBox1: {
    width: Platform.OS === "web" ? 170 : dimensions.marginHorizontal * 8.5,
    height: 160,
    borderColor: "rgba(0, 0, 0, 0.3)",
    borderWidth: 1,
    borderRadius: 8,
    borderStyle: "dashed",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 10,
  },
  exprienceBoxImage: {
    width: "100%",
    height: 150,
    borderRadius: 9,
  },
  outerExprienceBox: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: 'center',
    width: "100%",
    marginTop: 10,
    gap: 6
  },
  exprienceText: {
    fontSize: 16,
    color: "black",
    fontFamily: "EBGaramondMedium",
    fontWeight: "500",
    marginTop: 5,
  },
  lowerMainHead: {
    borderBottomWidth: 0.3,
    borderBottomColor: "rgba(0, 0, 0, 0.2)",
    height: 50,
    // backgroundColor:'green',
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  lowerMainHeadText: {
    fontSize: 18,
    opacity: 0.5,
    fontWeight: "500",
  },
  circleHeight: {
    backgroundColor: "white",
    height: 30,
    width: 30,
    borderRadius: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  circleBoxMain: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    height: 40,
    width: 70,
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: 40,
    paddingHorizontal: 4,
  },
});
